import React, { ImgHTMLAttributes } from 'react';

import styled from '@emotion/styled';
import { DesignsToken } from '@repo/tokens-studio';

import { SharpPersonaImage } from './SharpPersonaImage';

const ImageContainer = styled.div<Pick<IAvatarProps, 'size' | 'borderRadius'>>`
  width: ${({ theme, size }) => size && theme.size[size]};
  height: ${({ theme, size }) => size && theme.size[size]};
  overflow: hidden;

  picture {
    display: block;
    width: 100%;

    img {
      width: 100%;
      height: 100%;
      transition: border-radius 100ms;

      border-radius: ${({ theme, borderRadius }) =>
        theme.shape.corner[borderRadius]};
    }
  }
`;

const Image = styled.img<Pick<IAvatarProps, 'borderRadius'>>`
  width: 100%;
  aspect-ratio: 1 / 1;
  transition: border-radius 100ms;

  border-radius: ${({ theme, borderRadius }) =>
    theme.shape.corner[borderRadius]};
`;

export interface IAvatarProps
  extends Pick<ImgHTMLAttributes<HTMLImageElement>, 'alt' | 'src'> {
  borderRadius: keyof DesignsToken['shape']['corner'];
  size?: keyof DesignsToken['size'];
  className?: string;
  tokenId?: bigint | null | undefined;
}

export const Avatar = ({
  borderRadius,
  size,
  alt,
  src,
  className,
  tokenId,
}: IAvatarProps) => (
  <ImageContainer className={className} size={size} borderRadius={borderRadius}>
    {tokenId ? (
      <SharpPersonaImage tokenId={tokenId} alt={alt} />
    ) : (
      <Image borderRadius={borderRadius} src={src} alt={alt} />
    )}
  </ImageContainer>
);
